import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiDialogService, TuiIcon, TuiLoader, TuiTitle } from '@taiga-ui/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TuiSidebar } from '@taiga-ui/addon-mobile';
import { TuiActiveZone } from '@taiga-ui/cdk';
import { TUI_CONFIRM, TuiSwitch } from '@taiga-ui/kit';
import { FormsModule } from '@angular/forms';
import { LogoutComponent } from '../logout/logout.component';
import { ApplicationStore, MemberStore, ProjectStore } from '@ffx/app-store';
import { tap } from 'rxjs';
import { FeatureFlagService } from '@ffx/feature-flags';

@Component({
    selector: 'ffx-mobile-menu',
    standalone: true,
    imports: [
        CommonModule,
        TuiIcon,
        TuiSidebar,
        FormsModule,
        LogoutComponent,
        TuiSwitch,
        TuiActiveZone,
        TuiTitle,
        RouterModule,
        TuiLoader
    ],
    templateUrl: './mobile-menu.component.html',
    styleUrl: './mobile-menu.component.scss'
})
export class MobileMenuComponent implements OnInit {
    @Input() isDarkMode = true;
    @Output() toggleDarkModeEvent: EventEmitter<void> = new EventEmitter<void>();

    private route = inject(ActivatedRoute);
    private readonly dialogService = inject(TuiDialogService);
    private projectStore = inject(ProjectStore);
    private memberStore = inject(MemberStore);
    private appStore = inject(ApplicationStore);
    private featureFlagService = inject(FeatureFlagService);

    protected isOwner$ = this.projectStore.isOwner;
    id!: string;
    mobileMenuOpen = false;
    projectSettingsLoading$ = this.projectStore.projectSettingsLoading;
    leaveProjectLoading$ = this.memberStore.leaveProjectLoading;
    showHistory = this.featureFlagService.isFlagActive('history');

    ngOnInit(): void {
        this.id = this.route.snapshot.paramMap.get('id') ?? '';
    }

    toggleMobileMenu(open: boolean): void {
        this.mobileMenuOpen = open;
    }

    toggleDarkMode(): void {
        this.toggleDarkModeEvent.emit();
    }

    // TODO: Make custom dialog service
    exitProjectConfirmation(): void {
        this.dialogService
            .open<boolean>(TUI_CONFIRM, {
                label: `Are you sure you want to leave the '${this.projectStore.selectedProject().name}' project? You will have to ask an owner to add you again if you change your mind.`,
                size: 's',
                data: { yes: 'Leave', no: 'Cancel' }
            })
            .pipe(
                tap((confirmDelete: boolean) => {
                    if (confirmDelete) {
                        const selectedProject = this.projectStore.selectedProject();
                        this.memberStore.leaveProject(
                            selectedProject.name,
                            this.appStore.user().uid,
                            selectedProject.id
                        );
                    }
                })
            )
            .subscribe();
    }
}
